<div class="row mt-n1">
    <div class="col-md-12">
        <div class="card card-accent-success">
            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> Resultado
            </div>

            <div class="card-body-grid">

                <p-table #tableSearch autoLayout="true" [value]="result?.ResultList" [lazy]="true"
                    rowExpandMode="single"
                    [selectionMode]="mode === dialogMode.Dialog ? 'multiple': 'none'"
                    [(selection)]="arraySelectedEmpresas" dataKey="Id"
                    [lazyLoadOnInit]="false" [rowHover]="true"
                    (onLazyLoad)="onSearchLazy($event)" [paginator]="true" [columns]="cols" 
                    [rows]="result?.PageSize" sortField="NumeroRegistro"
                    [totalRecords]="result?.TotalCount" [loading]="loading" 
                    [ngClass]="displayGridHidden(result?.ResultList)"
                    styleClass="table table-responsive-sm  table-striped table-sm"
                    [scrollable]="true" scrollHeight="400px">

                    <ng-template pTemplate="header" let-columns let-expanded="expanded" let-rowIndex="rowIndex">
                        <tr>
                            <th *ngIf="mode === dialogMode.Dialog" class="th-md">&nbsp;</th>
                            <th scope="col" *ngFor="let col of columns" [ngClass]="{ 'th-xs': col.reduce }" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.field!=='Link' && col.field !== 'DadoDeBaja' && col.field!=='ExpandLink'" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                        <tr>
                            <td *ngIf="mode === dialogMode.Dialog">
                                <p-tableCheckbox [value]="rowData" (click)="onSelect($event, rowData)"></p-tableCheckbox>
                            </td>
                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                <ng-container *ngIf="col.field==='ExpandLink' && esDesautorizada(rowData)">
                                    <div class="btn-group">
                                        <div style="text-align: center;">
                                            <span>
                                                <a href="#" class="btn button-row-expand align-chevron" [pRowToggler]="rowData"
                                                    [title]="expanded ? 'Ocultar Campañas' : 'Mostrar Campañas'" 
                                                    [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                                </a>
                                            </span>
                                        </div>
                                        <span class="fa fa-ban" title="Desautorizada"></span>
                                    </div>
                                </ng-container>
                                <span *ngIf="col.field!=='Link' && col.field!=='ExpandLink' && col.field!=='Activo' && col.field !== 'DadoDeBaja'">{{ rowData[col.field] }}</span>
                                <span *ngIf="col.field==='Activo' || col.field==='DadoDeBaja'">{{ rowData[col.field] | siNo }}</span>
                                <ng-container *ngIf="col.field==='Link' && mode !== dialogMode.Dialog">
                                    <div *ngIf="showEditBtn(rowData)" class="btn-group">
                                        <button (click)="onEdit(rowData)" type="button" title="Editar" class="btn btn-sm btn-warning">
                                            <span class="fa fa-edit"></span>
                                        </button>
                                    </div>
                                    <div *ngIf="showViewBtn(rowData)" class="btn-group">
                                        <button (click)="onView(rowData)" type="button" class="btn btn-sm btn-info" title="Consultar">
                                            <span class="fa fa-eye"></span>
                                        </button>
                                    </div>
                                    <div *ngIf="showDeleteBtn(rowData)" class="btn-group">
                                        <button (click)="onDelete(rowData)" type="button" title="Eliminar" class="btn btn-sm btn-danger">
                                            <span class="fa fa-remove"></span>
                                        </button>
                                    </div>
                                    <div *ngIf="showUndeleteBtn(rowData)" class="btn-group">
                                        <button (click)="onUndoDelete(rowData)" type="button" [disabled]="readonly" class="btn btn-sm btn-warning" title="Deshacer">
                                            <span class="fa fa-undo"></span>
                                        </button>
                                    </div>
                                </ng-container>
                            </td>
                        </tr>

                    </ng-template>

                    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
                        <tr>
                            <th></th>
                            <th></th>
                            <th>Fecha</th>
                            <th colspan="6">Desautorizada en campaña</th>
                        </tr>
                        <tr *ngFor="let campania of rowData['CampaniasDesautorizado']">
                            <td></td>
                            <td>
                                <button *ngIf="showAuthorizeBtn(rowData)" (click)="onAuthorize(rowData, campania.Id)" type="button" class="btn btn-sm btn-warning" title="Autorizar Empresa deshidratadora en Campaña">
                                    <span class="fa fa-thumbs-o-up"></span>
                                </button>
                            </td>
                            <td>{{ campania?.Fecha | date:'dd/MM/yyyy HH:mm' }}</td>
                            <td colspan="6">{{ campania?.Descripcion }}</td>
                        </tr>
                    </ng-template>
                </p-table>
                <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
            </div>
        </div>
    </div>
</div>
